module.exports = CBOR;


//////////////////
// WEBPACK FOOTER
// external "CBOR"
// module id = 14
// module chunks = 0 1